@if (isBrowser && bannerData()?.active) {
  <div class="maintenance-banner" role="alert">{{ activeMessage() }}</div>
}
